export const systemLocales = {
  vi: {
    or: 'Hoặc',
    webinapp_only_title: 'Dịch vụ chỉ có tại ứng dụng Ahamove',
    webinapp_only_description:
      'Bạn hãy tải ứng dụng Ahamove để sử dụng dịch vụ này nhé!',
    access_denied_title: 'Bạn không thể truy cập trang này',
    access_denied_description:
      'Để truy cập trang, bạn hãy đăng nhập hoặc đăng ký tài khoản Ahamove nhé!',
  },

  en: {
    or: 'Hoặc',
    webinapp_only_title: 'Only available on our App',
    webinapp_only_description:
      "You'll find this service exclusively on the Ahamove app. Download it here!",
    access_denied_title: 'You’re unable to access this page',
    access_denied_description:
      'You’re missing the permission to access this page. Please log in or sign up to view the page.',
  },
};
export type SystemLocales = typeof systemLocales;
